interface SoundOffIconProps {
	className?: string
}

export default function SoundOffIcon({className}:SoundOffIconProps) {
	return (
		<svg className={className} viewBox="0 0 551 419" xmlns="http://www.w3.org/2000/svg"><path d="m0 142.6v134c0 1.1.9 2 2 2 108.2.4 182 35.8 287.1 137.3 6.4 6.1 17 1.6 17-7.2v-398.2c0-8.8-10.6-13.3-17-7.2-105.1 101.5-179.8 136.9-287 137.3-1.1 0-2 .9-2 2zm550.1-9.1-15.6-15.6c-.8-.8-2-.8-2.8 0l-71.9 71.9c-.8.8-2 .8-2.8 0l-71.9-71.9c-.8-.8-2-.8-2.8 0l-15.6 15.6c-.8.8-.8 2.1 0 2.8l71.9 71.9c.8.8.8 2.1 0 2.8l-71.9 71.9c-.8.8-.8 2 0 2.8l15.6 15.5c.8.8 2 .8 2.8 0l71.9-71.9c.8-.8 2-.8 2.8 0l71.9 71.9c.8.8 2 .8 2.8 0l15.6-15.6c.8-.8.8-2 0-2.8l-71.9-71.9c-.8-.8-.8-2.1 0-2.8l71.9-71.9c.8-.8.8-2 0-2.8z" fill="currentColor"/></svg>
	)
}